import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useParams } from "react-router";
import { FC } from "react";

export const AdminUserDetail: FC = () => {
  const { userId } = useParams();
  return (
    <Card className="max-w-xl mx-auto mt-8">
      <CardHeader>
        <CardTitle>User Details</CardTitle>
      </CardHeader>
      <CardContent>
        {/* TODO: Display user details here */}
        <div className="text-muted-foreground">Details for user: <span className="font-mono">{userId}</span></div>
      </CardContent>
    </Card>
  );
};
